<template>
	<el-dialog :modelValue="open" @update:modelValue="$emit('update:open', $event)" :title="'Neuen Fall erstellen'" @close="handleClose">
		<TheForm
			:model="request"
			:rules="rules"
			:waiting="waiting"
			:waitingMsg="texts.formErrors.waiting"
			:showErr="showErr"
			:errMsg="errMsg"
			ref="formRef"
			:id="id"
			:before-close="(done) => dialogBeforeClose(done, waiting)"
		>
			<el-form-item label="Fallname " prop="title">
				<el-input v-model="request.title" placeholder="Fallnamen eingeben" />
			</el-form-item>
		</TheForm>

		<template #footer>
			<div class="button-panel">
				<TheButton type="danger" @buttonclick="createCase" :disabled="waiting" :loading="waiting">Erstellen</TheButton>
				<TheButton type="default" @buttonclick="handleClose">Abbrechen</TheButton>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import TheForm from '../TheForm.vue';
import TheButton from '../TheButton.vue';
import { texts, translateToGerman } from '../../utils/texts';
import type { FormInstance } from 'element-plus';
import { createCaseFromComplaint } from '@/requests/complaints';
import { CreateCaseFromComplaintRequest } from '@/types/types';
import { validateForm, resetForm, dialogBeforeClose } from '@/utils/functions';

export default defineComponent({
	name: 'DialogCreateCaseFromComplaint',
	data() {
		return {
			request: {
				title: '',
			},
			rules: {
				title: [{ required: true, message: texts.formErrors.reqMissing, trigger: ['blur'] }],
			},
			id: 'createCaseFromComplaintForm',
			waiting: false,
			showErr: false,
			errMsg: texts.complaints.createCaseFailed,
		};
	},
	components: {
		TheForm,
		TheButton,
	},
	props: {
		open: {
			type: Boolean,
			required: true,
		},
		complaintId: {
			type: String,
			required: true,
		},
	},
	setup() {
		const formRef = ref<FormInstance | null>(null);

		return {
			formRef,
		};
	},
	computed: {
		texts() {
			return texts;
		},
	},
	emits: ['reload', 'update:open'],
	methods: {
		async createCase() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.waiting = true;

			const requestCreateCase = {
				complaintId: String(this.complaintId),
				title: this.request.title,
			} as CreateCaseFromComplaintRequest;

			const result = await createCaseFromComplaint(requestCreateCase);

			if (result.success) {
				this.$router.push({ name: 'FallDetail', params: { id: String(result.data.id) } });
				// this.handleClose(true);
			} else {
				const msg = translateToGerman(result.error);
				if (msg) {
					this.errMsg = msg;
				}
				this.showErr = true;
			}

			this.waiting = false;
		},
		handleClose(reload: Boolean) {
			resetForm(this.formRef, this.id);
			this.showErr = false;

			if (reload) {
				this.$emit('reload');
			}
			this.$emit('update:open', false);
		},
		dialogBeforeClose,
	},
});
</script>
